import { Stack, Text } from "@chakra-ui/react";

type CodeCellProps = {
  code: string;
  padded: boolean;
};
export const CodeCell = ({ code, padded }: CodeCellProps) => (
  <Stack gap={0}>
    <Text>{code}</Text>
    {padded && (
      <Text textStyle="xs" color="fg.muted">
        Complété à 5 caractères
      </Text>
    )}
  </Stack>
);
